import { render, staticRenderFns } from "./service.vue?vue&type=template&id=22812369&"
import script from "./service.vue?vue&type=script&lang=js&"
export * from "./service.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports